import { addHeader, addHeaderWithOutBody } from './headers';
import constants, { environment } from './api_urls';
import { AUTH_ENDPOINTS } from './api_endpoints';

// Validate and normalize environment - only accept 'prod', 'qa', or 'future'
const getValidEnvironment = () => {
  const env = localStorage.getItem('environment') || 'prod';
  // Only allow valid environments, default to 'prod' for invalid values
  if (env === 'prod' || env === 'qa' || env === 'future') {
    return env;
  }
  console.warn(
    `Invalid environment "${env}" detected. Defaulting to 'prod'. Valid values are: 'prod', 'qa', 'future'`,
  );
  // Clear invalid environment and set to prod
  localStorage.setItem('environment', 'prod');
  return 'prod';
};

/** Re-read env on each call so axios/fetch match cookies + API host after env switches. */
export function getBaseMainUrl() {
  const validEnvironment = getValidEnvironment();
  return validEnvironment === 'prod'
    ? constants.prodUrl + '/api'
    : validEnvironment === 'qa'
      ? constants.qaUrl + '/api'
      : constants.futureUrl + '/api';
}

export function getBasePublicUrl() {
  const validEnvironment = getValidEnvironment();
  return validEnvironment === 'prod'
    ? constants.prodUrl + '/public'
    : validEnvironment === 'qa'
      ? constants.qaUrl + '/public'
      : constants.futureUrl + '/public';
}

/** @deprecated Prefer getBaseMainUrl() — this was fixed at first import and could go stale. */
export const baseMainUrl = getBaseMainUrl();
export const basePublicUrl = getBasePublicUrl();

const shouldSkipRefresh = (path = '') =>
  path.includes(AUTH_ENDPOINTS.LOGIN_ADMIN_EMAIL) ||
  path.includes(AUTH_ENDPOINTS.REFRESH_ADMIN) ||
  path.includes(AUTH_ENDPOINTS.REFRESH_RECRUITER);

const tryRefreshSession = async () => {
  const base = getBaseMainUrl();

  try {
    const adminRefreshResp = await fetch(
      base + AUTH_ENDPOINTS.REFRESH_ADMIN,
      await addHeader({}, 'POST'),
    );
    if (adminRefreshResp.ok) return true;
  } catch (adminRefreshError) {
    // Fall through and try recruiter refresh.
  }

  try {
    const recruiterRefreshResp = await fetch(
      base + AUTH_ENDPOINTS.REFRESH_RECRUITER,
      await addHeader({}, 'POST'),
    );
    return recruiterRefreshResp.ok;
  } catch (recruiterRefreshError) {
    return false;
  }
};

const fetchWithRefreshRetry = async (path, options, allowRefresh = true) => {
  const response = await fetch(getBaseMainUrl() + path, options);

  if (
    allowRefresh &&
    (response.status === 401 || response.status === 400) &&
    !shouldSkipRefresh(path)
  ) {
    const refreshed = await tryRefreshSession();
    if (refreshed) {
      return fetch(getBaseMainUrl() + path, options);
    }
  }

  return response;
};

export async function apiGet(path) {
  const response = await fetchWithRefreshRetry(path, await addHeaderWithOutBody('GET'));
  console.log(response);

  const data = await response.json();
  return { body: data, status: response.status };
}

export async function apiGetPublic(path) {
  const response = await fetch(getBasePublicUrl() + path, await addHeaderWithOutBody('GET'));
  console.log(response);

  const data = await response.json();
  return { body: data, status: response.status };
}

export async function apiGetOpenSource(uriPath) {
  const response = await fetch(uriPath, await addHeaderWithOutBody('GET'));

  const data = await response.json();
  return { body: data, status: response.status };
}

export async function apiDelete(path) {
  const response = await fetchWithRefreshRetry(path, await addHeaderWithOutBody('DELETE'));
  console.log(response);
  let data = {};
  try {
    data = await response.json();
  } catch {
    data = {};
  }
  return { body: data, status: response.status };
}

export async function apiPostPut(body, path, method) {
  const base = getBaseMainUrl();
  console.log(base + path);
  console.log(environment);
  const response = await fetchWithRefreshRetry(path, await addHeader(body, method));

  const data = await response.json();
  return { body: data, status: response.status };
}

export async function apiPostPutPublic(body, path, method) {
  const pub = getBasePublicUrl();
  console.log(pub + path);
  console.log(environment);
  const uri = pub + path;
  const response = await fetch(uri, {
    method: method,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    credentials: 'include',
    body: JSON.stringify(body),
  });

  const data = await response.json();
  return { body: data, status: response.status };
}
